import request from '@/utils/request'

// 作品详情
export function getInfo(data) {
  return request({
    url: '/api/student_works/info',
    method: 'get',
    params: data
  })
}

// 评论列表
export function getComment(data) {
  return request({
    url: '/api/student_works/comment',
    method: 'get',
    params: data
  })
}

// 发表评论
export function addComment(data) {
  return request({
    url: '/api/student_works/comment',
    method: 'post',
    data
  })
}

// 评论点赞 1：点赞 2：取消点赞
export function changeLike(data) {
  return request({
    url: '/api/student_works/comment/like/' + data.id,
    method: 'put',
    data
  })
}


// 添加或更新批注
export function addReview(data) {
  return request({
    url: '/api/student_works/addreview',
    method: 'post',
    data
  })
}

// 删除批注
export function delReview(data) {
  return request({
    url: '/api/student_works/review/del',
    method: 'delete',
    params: data
  })
}

// 评论点赞 1：点赞 2：取消点赞
export function changeReviewLike(data) {
  return request({
    url: '/api/student_works/like/',
    method: 'put',
    data
  })
}

// 收藏作品
export const workCollect = (data) => request.post(`/api/student_works/collect`, data)



// WEBPACK FOOTER //
// ./src/api/stuWorkdtcms.js